import { render, staticRenderFns } from "./licai.vue?vue&type=template&id=4d83c768&scoped=true&"
import script from "./licai.vue?vue&type=script&lang=js&"
export * from "./licai.vue?vue&type=script&lang=js&"
import style0 from "./licai.vue?vue&type=style&index=0&id=4d83c768&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83c768",
  null
  
)

export default component.exports